import React from 'react';
import propTypes from 'prop-types';
import Select from 'react-select';
import debounce from 'debounce-promise';
import api from '../../../../utils/Api';
import { AUTH_TOKEN_KEY } from '../../../../constants';

class SelectVariantGroup extends React.Component {
  constructor(props) {
    super(props);
    this.loadSelectOptions = this.loadSelectOptions.bind(this);
    this._loadOptions = this._loadOptions.bind(this);
    this._debouncedLoadOptions = debounce(this._loadOptions, 300);
  }

  componentWillUnmount() {
    if (this._debouncedLoadOptions.cancel) {
      this._debouncedLoadOptions.cancel();
    }
  }

  loadSelectOptions(input) {
    return this.refs[this.props.id].loadOptions(input);
  }

  _loadOptions(input) {
    const myToken = localStorage.getItem(AUTH_TOKEN_KEY);
    const headers = { 'Authorization': `Bearer ${myToken}` };
    const params = {
      keyword: input,
      active: 1,
      ...this.props.paramsApi
    };
    return api(headers).get('/admins/variant-groups', { params })
      .then(({ data }) => {
        const options = data.data.map(item => ({
          id: item.id,
          name: item.name
        }));
        if (this.props.onSelectSearch) {
          this.props.onSelectSearch(input);
        }
        return { options };
      });
  }

  render() {
    return (
      <Select.Async
        valueKey="id"
        labelKey="name"
        ref={this.props.id}
        loadOptions={this._debouncedLoadOptions}
        id={this.props.id}
        name={this.props.name}
        value={this.props.value}
        placeholder={this.props.placeholder}
        noResultsText={this.props.noResultsText}
        onChange={this.props.onSelectChange}
        multi={this.props.isMulti}
        disabled={this.props.isDisabled}
      />
    );
  }
}

export default SelectVariantGroup;

SelectVariantGroup.defaultProps = {
  isMulti: false,
  value: null,
  placeholder: 'Select a variant group...',
  noResultsText: 'No Result!',
  paramsApi: {},
  isDisabled: false
};

SelectVariantGroup.propTypes = {
  id: propTypes.string.isRequired,
  name: propTypes.string,
  value: propTypes.object,
  placeholder: propTypes.string,
  noResultsText: propTypes.string,
  paramsApi: propTypes.object,
  isDisabled: propTypes.bool,
  onSelectSearch: propTypes.func,
  onSelectChange: propTypes.func
};
